import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface ReviewLikeRecommenderType {
	likeId: number;
	reviewId: number;
}

const key = `useReviewLikeRecommender`;

/** ```
 * 고객리뷰 추천 조회
 *   `/bff/portal/reviewLikeRecommender`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const getPath = () => `/bff/portal/reviewLikeRecommender`;

/** ```
 * 고객리뷰 추천 조회
 *   `/bff/portal/reviewLikeRecommender`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const useReviewLikeRecommender = (
	goodsCd?: string,
	options?: Partial<UseQueryOptions<Response<ReviewLikeRecommenderType[]>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath()],
		queryFn: () => useConfigureAxios({url: getPath(), params: {goodsCd}}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		throwOnError: false,
		...options,
	});

export default useReviewLikeRecommender;
export {getPath, key};
export type {ReviewLikeRecommenderType};
